<template>
  <div>
    <div>
      <div class="jumbotron"></div>
    </div>
      <section>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 JY-about">
              <h2><em></em>发布信息<span><em>Publish Freight Info</em></span></h2>
              <span style="font-size: 10px;color: red;">每条信息发布需要2元信息费</span>
              <div style="height:20px;"></div>
            </div>
          </div>
          <el-form ref="dataFormWatch" :model="dataForm" label-position="right" label-width="130px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="发货地址" prop="beginAddress">
                  <el-input v-model="dataForm.beginAddress"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收货地址" prop="endAddress">
                  <el-input v-model="dataForm.endAddress"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="货物信息" prop="cargoInfo">
                  <el-input v-model="dataForm.cargoInfo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发布时间" prop="pulishTime">
                  <el-input v-model="dataForm.pulishTime"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人" prop="contacts">
                  <el-input v-model="dataForm.contacts"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" prop="contactInfo">
                  <el-input v-model="dataForm.contactInfo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="row">
            <div class="col-lg-6 col-sm-12 mb-4 mt-2s ml-auto mr-auto text-center">
              <button type="button" style="margin-left:10px;" class="btn btn-primary">提交</button>
            </div>
          </div>

        </div>
      </section>
  </div>
</template>
<script>
  import condition from '../components/condition'
  
  export default {
    components: {
      condition
    },
    data() {
      return {
        dataForm: {
          beginAddress:null,
          endAddress:null,
          cargoInfo:null,
          contacts:null,
          contactInfo:null,
          pulishTime:null,
        },

      };
    },
    methods: {
      createData(){

      },


    }
  };
</script>
<style>
  .jumbotron {
    background: url(../assets/images/real2.jpg) no-repeat;
    background-size: cover;
    min-height: 200px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/PublishFreightInfo.vue